import React, { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";

const A4_WIDTH = 794; // 210mm @ 96dpi
const A4_HEIGHT = 1123; // 297mm @ 96dpi

/**
 * Viser dokument-HTML (samme HTML som blir PDF) i en sandboxed iframe som alltid
 * rendres i A4-bredde og skaleres ned til containerens bredde – også på mobil.
 */
export const DocumentPreview = ({ html, title = "Dokument", pages = 1, className, testId = "document-preview" }) => {
  const ref = useRef(null);
  const [scale, setScale] = useState(1);
  const [docHeight, setDocHeight] = useState(A4_HEIGHT * pages + 40);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const update = () => setScale(Math.min(1, el.clientWidth / A4_WIDTH));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const onLoad = (e) => {
    try {
      const h = e.target.contentDocument?.documentElement?.scrollHeight;
      if (h && h > 200) setDocHeight(h + 24);
    } catch {
      /* sandbox uten same-origin: bruk standardhøyde */
    }
  };

  return (
    <div ref={ref} className={cn("w-full overflow-hidden", className)} style={{ height: Math.round(docHeight * scale) }} data-testid={testId}>
      <iframe
        title={title}
        srcDoc={html}
        sandbox="allow-same-origin"
        onLoad={onLoad}
        className="border-0 bg-transparent"
        style={{ width: A4_WIDTH, height: docHeight, transform: `scale(${scale})`, transformOrigin: "top left" }}
        data-testid={`${testId}-iframe`}
      />
    </div>
  );
};
